/** technical proposal: actions files stay, sworkit-store becomes the new "state", this is an example to aid with the transition */

import SworkitMobile from "../global/sworkit-mobile/sw-mobile";
import { Capacitor } from "@capacitor/core";
import healthIntegration, { HealthStore } from "../stencil-store/health.store";
import { HealthIntegrationKey, User } from "@sworkit/api";
import workoutLogs from "../stencil-store/workout-logs.store";
import {
  syncWorkoutLogsFromHealth,
  syncWorkoutLogsToHealth,
} from "./workout-logs";
import { doc, setDoc } from "firebase/firestore";
import { fst as firestore } from "../global/firebase";
import { getUserId } from "@amplitude/analytics-browser";
import { isNativeHealthIntegrationKey } from "../global/health";

export async function syncAllHealth(member: User) {
  const recentWorkoutLogs = workoutLogs.recent;
  await Promise.all([
    syncWorkoutLogsToHealth(recentWorkoutLogs),
    syncWorkoutLogsFromHealth(member),
    getStepsFromHealth(member),
  ]);
}

export async function getStepsFromHealth(member: User) {
  if (isNativeHealthIntegrationKey(member?.account?.stepSource)) {
    SworkitMobile.readStepCount();
  }
}

export async function unsetStepApp() {
  const uid = getUserId();
  await setDoc(
    doc(firestore, `users/${uid}`),
    { account: { stepSource: null } },
    { merge: true },
  );
}

export async function getAvailableNativeHealthApps() {
  const platform = Capacitor.getPlatform();
  if (platform == "android") {
    //  check if google fit is available including if the date
    // is before June 30 2025 when it is being wound down by Google
    const { available: googleFitIsAvailable } =
      await SworkitMobile.isHealthAvailable({ integration: "google-fit" });
    if (googleFitIsAvailable && Date.now() < 1751259600000) {
      addServiceToIntegration("availableIntegrations", "google-fit");
    } else {
      removeServiceFromIntegration("availableIntegrations", "google-fit");
    }

    const { available: healthConnectIsAvailable } =
      await SworkitMobile.isHealthAvailable({ integration: "health-connect" });
    console.log({ healthConnectIsAvailable });
    if (healthConnectIsAvailable) {
      addServiceToIntegration("availableIntegrations", "health-connect");
    } else {
      removeServiceFromIntegration("availableIntegrations", "health-connect");
    }
  }

  if (platform == "ios") {
    const { available } = await SworkitMobile.isHealthAvailable({
      integration: "apple-health",
    });
    if (available) {
      addServiceToIntegration("availableIntegrations", "apple-health");
    } else {
      removeServiceFromIntegration("availableIntegrations", "apple-health");
    }
  }
}

export function addServiceToIntegration(
  key: Extract<
    keyof HealthStore,
    | "writeEnabledIntegrations"
    | "readEnabledIntegrations"
    | "availableIntegrations"
  >,
  service: HealthIntegrationKey,
) {
  const newServices = new Set(healthIntegration[key] || []).add(service);
  healthIntegration[key] = [...newServices];
}

export function removeServiceFromIntegration(
  key: Extract<
    keyof HealthStore,
    | "writeEnabledIntegrations"
    | "readEnabledIntegrations"
    | "availableIntegrations"
  >,
  service: HealthIntegrationKey,
) {
  const services = new Set(healthIntegration[key] || []);
  services.delete(service);
  healthIntegration[key] = [...services];
}
